import React, { useState, useRef, useEffect } from "react";

export default function CategoryAutocomplete({ categories, value, onChange }) {
  const [open, setOpen]       = useState(false);
  const [query, setQuery]     = useState("");
  const [highlight, setHighlight] = useState(0);
  const wrapRef = useRef(null);

  // 선택된 카테고리 이름을 인풋에 표시 (외부에서 value 바뀌면 동기화)
  const selected = categories.find((c) => String(c.id) === String(value));
  useEffect(() => {
    setQuery(selected ? selected.name : "");
  }, [value, categories]); // eslint-disable-line

  // 바깥 클릭하면 닫기
  useEffect(() => {
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  // query로 필터링 (query가 선택된 이름과 같으면 전체 표시)
  const filtered =
    !query || (selected && query === selected.name)
      ? categories
      : categories.filter((c) => c.name.toLowerCase().includes(query.toLowerCase()));

  const pick = (cat) => {
    onChange(cat.id);
    setQuery(cat.name);
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (!open && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setOpen(true);
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlight((h) => Math.min(h + 1, filtered.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlight((h) => Math.max(h - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (open && filtered[highlight]) pick(filtered[highlight]);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  return (
    <div ref={wrapRef} style={{ position: "relative", width: "100%" }}>
      <input
        type="text"
        value={query}
        placeholder="카테고리 검색 또는 선택"
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
          setHighlight(0);
          if (e.target.value === "") onChange("");  // 비우면 선택 해제
        }}
        onFocus={() => { setOpen(true); setHighlight(0); }}
        onKeyDown={handleKeyDown}
        style={{
          width: "100%", height: 38, padding: "0 10px", boxSizing: "border-box",
          border: "1px solid #d0d7de", borderRadius: 6, fontSize: 14
        }}
      />
      {open && filtered.length > 0 && (
        <ul style={{
          position: "absolute", top: "100%", left: 0, right: 0, zIndex: 20,
          margin: "2px 0 0", padding: 4, listStyle: "none",
          background: "#fff", border: "1px solid #d0d7de", borderRadius: 6,
          maxHeight: 200, overflowY: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
        }}>
          {filtered.map((cat, i) => (
            <li
              key={cat.id}
              onMouseDown={(e) => { e.preventDefault(); pick(cat); }}
              onMouseEnter={() => setHighlight(i)}
              style={{
                padding: "7px 10px", fontSize: 14, borderRadius: 4, cursor: "pointer",
                background: i === highlight ? "#4361ee" : "transparent",
                color: i === highlight ? "#fff" : "#222"
              }}
            >
              {cat.name}
            </li>
          ))}
        </ul>
      )}
      {open && filtered.length === 0 && (
        <div style={{
          position: "absolute", top: "100%", left: 0, right: 0, zIndex: 20,
          margin: "2px 0 0", padding: "8px 10px", fontSize: 13, color: "#999",
          background: "#fff", border: "1px solid #d0d7de", borderRadius: 6
        }}>
          일치하는 카테고리가 없습니다
        </div>
      )}
    </div>
  );
}